import state from './state'
import getters from './getters'

// This module kinda "extends" the auth module created by nuxt-auth.
export default {
  namespaced: true,
  state,
  getters,
}
